module.exports = __webpack_public_path__ + "media/Loops 110 Strings 3.33aa5a3a.wav";